export const getBackendURL = (host) => process.env.NODE_ENV === "production" ? `https://${host}/api/` : process.env.REACT_APP_API_URL;;
